import React from "react"
import { useField, useFormikContext } from "formik"
import DateTimePicker from "react-datetime-picker"

import "./index.scss"
const DateTimePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext()
  const [field] = useField(props)
  return (
    <div id="DateTimePickerField" className="date-time-picker-field">
      <DateTimePicker
        {...field}
        {...props}
        className="form-control"
        selected={(field.value && new Date(field.value)) || null}
        onChange={val => {
          setFieldValue(field.name, val)
        }}
      />
    </div>
  )
}

export default DateTimePickerField
